import { __values } from 'tslib';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { SessionService } from './session.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { UserProfile } from './../../models/user/user-profile.model';


@Injectable({ providedIn: 'root' })
export class AuthService {
  public isLoggedIn: Observable<boolean> = new Observable<boolean>();
  public loggedInUser: Observable<UserProfile> = new Observable<UserProfile>();

  constructor(
    private http: HttpClient,
    private sessionService: SessionService,
    private router: Router
  ) {
    const isLoggedIn = true;
    this.isLoggedIn = new Observable((observer) => {
      observer.next(isLoggedIn);
      observer.complete();
    });
  }

  public completeAuthentication(): void {
    this.getAccessToken().subscribe((result: any) => {
      this.sessionService.createSession(result.token);
      this.getLoginUserInfo().subscribe((token: UserProfile) => {
        if (!token) {
          this.router.navigate(['/error-found']);
        } else if (token && token.userId === 0) {
          this.router.navigate(['/error-found']);
        } else {
          this.loggedInUser = new Observable<UserProfile>(observer => {
            observer.next(token);
          });
          this.router.navigate(['/']);
        }
      });
    }, (err: any) => {
      if (err.error === 'SAML user not found.') {
        this.router.navigate(['/error-found']);
      } else {
        this.sessionService.logOut();
        window.location.href = '/Fallback/ForceSO';
      }
    },

    );
  }

  getAccessToken(): any {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/Authentication/SignIn`, { headers })
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getToken(): UserProfile|null {
    this.getLoginUserInfo().subscribe((result: UserProfile) => {
      return result;
    });
    return null;
  }

  getLoginUserInfo(): Observable<UserProfile> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<UserProfile>(`${environment.config.baseAppURL}/UserManagement/GetLoginUserInfo`, { headers });
  }


  isLoggedInSuccess(): Observable<UserProfile> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<UserProfile>(`${environment.config.baseAppURL}/UserManagement/IsLoggedIn`, { headers });
  }

  logOut(): any {
    this.sessionService.logOut();
    window.location.href = '/Fallback/ForceSO';
  }

  forceSignOff(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`/Fallback/ForceSO`, { headers });
  }

  getCSRFToken(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/Authentication/GetCSRFToken`, { headers });
  }
}
